import { fontSize } from '@mui/system';
import React from 'react';
import Collapse from '@mui/material/Collapse';
import pagebackground from "../images/resumepagebackground.jpg"
import headshot from "../images/Headshot.jpg"
import { CardContent, ListItemAvatar, Typography } from '@mui/material';
import { Card } from 'react-bootstrap';


import './pagesStyles.css';


  

const Resume = () => {

	const onButtonClick = () => {
        // using Java Script method to get PDF file
        fetch('Davis Kajuna Resume.pdf').then(response => {
            response.blob().then(blob => {
                // Creating new object of PDF file
                const fileURL = window.URL.createObjectURL(blob);
                // Setting various property values
                let alink = document.createElement('a');
                alink.href = fileURL;
                alink.download = 'Kajuna Davis resume.pdf';
                alink.click();
            })
        })
    }

	

return (
<div style={{ backgroundImage:`url(${pagebackground})` }}>
<div className='resumecards' >
	<Card className='introCard'>
		<CardContent>
			<img className='headshotResume' src={headshot} height="150px" width="150px" display="inline" style={{borderRadius: "50%", }}></img>
			<Typography  sx={{paddingLeft:"1%", paddingTop: "1%", color:"seaGreen", fontSize: "30px", fontFamily: "serif"}}>Davis Kajuna</Typography>
			<Typography sx={{fontFamily: "Roboto", paddingLeft:"1%" }}>davis1kajuna@gmail.com | 571-***-**** | <a href="https://www.linkedin.com/in/davis-
kajuna-028b5b168/" target="_blank">LinkedIn</a> </Typography>
			<Typography>
                <button onClick={onButtonClick} >
                    Download resume
                </button>
			</Typography>
		</CardContent>
	</Card>
	<Card className='experienceCard'>
		<CardContent>
			<Typography sx={{paddingLeft:"7%", color:"red"}}>
				EXPERIENCE
			</Typography>
			<Typography sx={{fontFamily: "Roboto", paddingLeft:"7%" }}>
				June 2022 - October 2023<br></br>
				Data & AI practitioner (Accenture)
				<ul>
					<li>Worked as a data analyst or scientist depending on client work.</li>
					<li>Worked in implementing automation of files and data pipelines.</li>
					<li>Wrote python automation scripts for conducting data lineage on snowflake databases</li>
				</ul>
				
				
				
			</Typography>
			
			<Typography sx={{fontFamily: "Roboto", paddingLeft:"7%", paddingTop:"4%"}}>
				January 2022 - May 2022
				<br></br>
				Data science assistant (Center for mind and culture)
				<ul>
					<li>Wrote cleaning and standardizing R scripts for data.</li>
					<li>Created visualizations used in Phd research briefings.</li>
					<li>Created machine learning models (logistic models).</li>
					<li>Conducted statistical tests to analyze datasets (ANOVA).</li>
				</ul>
			</Typography>

		</CardContent>
	</Card>

	<Card className='educationCard'>
		<CardContent>
			<Typography sx={{paddingLeft:"7%" , color:"red"}}>
				EDUCATION
			</Typography>
			
			<Typography sx={{fontFamily: "Roboto", paddingLeft:"7%", paddingTop:"4.4%"}}>
				George Mason University, Fairfax Virginia
			<ul>
				<li>August 2022 – Present: Master of Science in statistical sciences.</li>
				<li>August 2020 – May 2022: Bachelor of Science in computational and datasciences.</li>
				
			</ul>
			</Typography>

			<Typography sx={{fontFamily: "Roboto", paddingLeft:"7%" , paddingTop:"4.4%"}}>
			Northern Virginia Community College, Sterling, Virginia
			<ul>
				<li>August 2018 – May 2020: Associates in computer science.</li>
			</ul>
			
			</Typography>
		</CardContent>
	</Card>

	<Card className='skillsCard'>
		<CardContent>
			<Typography sx={{paddingLeft:"7%" , color:"red"}}>
				KEY SKILLS
			</Typography>
			<Typography sx={{fontFamily: "Roboto", paddingLeft:"7%" }}>
				<ul>
					<li>Programming Languages</li>
					Python, R, Javascript, Java, Fortran, C++
					<li>Data tools</li>
					SQL, Tableau
					<li>Data Practices</li>
					Data visualization, data modelling, statistical modelling
					<li>Cloud</li>
					Snowflake, aws
				</ul>
			</Typography>
		</CardContent>
	</Card>

	<Card className='projectCard' >
		<CardContent>
			<Typography sx={{paddingLeft:"7%" , color:"red"}}>
				PROJECTS
			</Typography>
			<Typography sx={{fontFamily: "Roboto", paddingLeft:"7%" }}>
				<ol>
					<li>Stem salaries Visualizations</li>
					<li>Credit Loan risk evaluation</li>
				</ol>
				
			</Typography>
		</CardContent>
	</Card>

	<Card className='subjectCard' >
		<CardContent>
			<Typography sx={{paddingLeft:"7%" , color:"red"}}>
				RELATIVE SUBJECTS
			</Typography>
			<Typography sx={{fontFamily: "Roboto", paddingLeft:"7%" }}>
				<ul>
					<li>Statistics and probability for engineers</li>
					<li>Scientific Databases</li>
					<li>Modelling and simulation</li>
					<li>Scientific information and data visualization</li>
					<li>Scientific data mining</li>
					<li>Machine learning</li>
					<li>Intro to scientific programming with fortran</li>
					<li>Agent based modelling</li>
					<li>Operations research</li>
				</ul>
			</Typography>
		</CardContent>
	</Card>

	
</div>
</div>
	
);
};

export default Resume;

